module.exports = __webpack_public_path__ + "static/media/mongoNewsScraper.fe42ae01.png";